<template>
  <div class="modal_login_box">
    <div class="login_header">
      <div class="header_pc">
        <router-link to="/index">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="icon-clear" />
          </button>
        </router-link>
      </div>
    </div>
    <div class="login_body">
      <div class="login_left">
        <div class="login_banner_m">
          <img src="@/assets/theme4/img/login_banner.jpg">
        </div>
        <h5 class="login_title">
          {{ $t("Bao.login") }}
        </h5>
        <div class="login_other d-grid">
          <div class="form-group mb-0" @click="changeLoginType('username')">
            <input id="account_type_radio_phone_1" type="radio" name="account_type_radio_phone" class="account_type_radio-input r-account" value="account" checked>
            <label id="account_type_label_phone_1" for="account_type_radio_phone_1" class="account_type_radio-label r-account">
              <svg xmlns="http://www.w3.org/2000/svg" width="16.638" height="20.289" viewBox="0 0 16.638 20.289">
                <g id="member" transform="translate(-39.899 -9.542)" opacity="0.997">
                  <path id="Path_577" data-name="Path 577" d="M47.12,528.8c-4.593,0-8.32,3.137-8.32,7.01a2.584,2.584,0,0,0,2.773,2.337H52.665a2.583,2.583,0,0,0,2.773-2.337C55.439,531.939,51.713,528.8,47.12,528.8Z" transform="translate(1.099 -508.316)" fill="#ddd" />
                  <path id="Path_578" data-name="Path 578" d="M269.4,15.1a5.1,5.1,0,1,0,5.1-5.1A5.1,5.1,0,0,0,269.4,15.1Z" transform="translate(-226.283 -0.458)" fill="#ddd" />
                </g>
              </svg>
              <span>{{ $t('Bao.account_login') }}</span>
            </label>
          </div>
          <div class="form-group mb-0" @click="changeLoginType('phone')">
            <input id="account_type_radio_phone_2" type="radio" name="account_type_radio_phone" class="account_type_radio-input r-phone" value="phone">
            <label id="account_type_label_phone_2" for="account_type_radio_phone_2" class="account_type_radio-label r-phone">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="21" viewBox="0 0 17 21">
                <g id="mobile" transform="translate(-563 -408)">
                  <rect id="Rectangle_1459" data-name="Rectangle 1459" width="17" height="21" rx="2" transform="translate(563 408)" fill="#e3e3e3" />
                  <rect id="Rectangle_1460" data-name="Rectangle 1460" width="11" height="14" transform="translate(566 411)" fill="#fff" />
                  <circle id="Ellipse_240" data-name="Ellipse 240" cx="1" cy="1" r="1" transform="translate(570.5 426)" fill="#fff" />
                </g>
              </svg>
              <span>{{ $t('Bao.phone_login') }}</span>
            </label>
          </div>
        </div>
        <div class="login_form bank_area">
          <div v-if="loginType=='phone'" class="form-group form-phone">
            <div class="form-group-inner">
              <vue-tel-input
                v-model="postForm.username"
                v-validate="'required'"
                class="vti__input form_ipt form-control"
                maxlength="25"
                :placeholder="$t('Bao.please_input')+$t('Bao.phone')"
                name="username"
                :data-vv-as="$t('Bao.phone')"
                :only-countries="countryList"
                :default-country="defaultCountry"
                mode="international"
                :required="true"
                autocomplete="off"
              />
            </div>
          </div>
          <div v-else class="form-group form-username">
            <div class="form-group-inner">
              <svg xmlns="http://www.w3.org/2000/svg" width="16.638" height="20.289" viewBox="0 0 16.638 20.289">
                <g id="member" transform="translate(-39.899 -9.542)" opacity="0.997">
                  <path id="Path_577" data-name="Path 577" d="M47.12,528.8c-4.593,0-8.32,3.137-8.32,7.01a2.584,2.584,0,0,0,2.773,2.337H52.665a2.583,2.583,0,0,0,2.773-2.337C55.439,531.939,51.713,528.8,47.12,528.8Z" transform="translate(1.099 -508.316)" fill="#ddd" />
                  <path id="Path_578" data-name="Path 578" d="M269.4,15.1a5.1,5.1,0,1,0,5.1-5.1A5.1,5.1,0,0,0,269.4,15.1Z" transform="translate(-226.283 -0.458)" fill="#ddd" />
                </g>
              </svg>
              <span class="position-relative">
                <input
                  v-model="postForm.username"
                  v-validate="'required'"
                  class="account_form_ipt w-100 is_false"
                  :placeholder="$t('Bao.member_username_limit')"
                  type="text"
                  name="username"
                  :data-vv-as="$t('Bao.username')"
                  autocomplete="off"
                >
              </span>
            </div>
            <small v-if="errors.has('username')" class="help-block">{{ errors.first('username') }}</small>
          </div>
          <div class="form-group">
            <div class="form-group-inner">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.018" height="20.8" viewBox="0 0 17.018 20.8">
                <path id="Path_576" data-name="Path 576" d="M103.827,19.456h7.564V16.618a3.782,3.782,0,0,0-7.564,0v2.838Zm12.291,1.418v8.509A1.413,1.413,0,0,1,114.7,30.8H100.518A1.413,1.413,0,0,1,99.1,29.382V20.873a1.413,1.413,0,0,1,1.418-1.418h.473V16.618A6.66,6.66,0,0,1,107.609,10a6.364,6.364,0,0,1,4.667,1.951,6.368,6.368,0,0,1,1.951,4.667v2.836h.473a1.413,1.413,0,0,1,1.418,1.42Z" transform="translate(-99.1 -10)" fill="#e3e3e3" />
              </svg>
              <span class="position-relative">
                <input
                  v-model="postForm.password"
                  v-validate="'required|min:6'"
                  class="account_form_ipt w-100"
                  :placeholder="$t('Bao.password_notice')"
                  type="password"
                  name="password"
                  :data-vv-as="$t('Bao.password')"
                  autocomplete="new-password"
                >
              </span>
            </div>
            <small v-if="errors.has('password')" class="help-block">{{ errors.first('password') }}</small>
          </div>
          <div class="form-group">
            <div class="d-flex justify-content-between">
              <router-link class="login_forget" to="/user/register">
                {{ $t("Bao.register_new_user") }}
              </router-link>
              <router-link class="login_forget" to="/user/forget">
                {{ $t("Bao.forget_password") }}
              </router-link>
            </div>
          </div>
          <div class="form-group mt-40">
            <button
              class="btn login_btn w-100 border-0"
              type="button"
              :disabled="actionLoading"
              @click="handleUpdate"
            >
              <b>{{ $t("Bao.login") }}</b>
            </button>
          </div>
        </div>
      </div>
      <div class="login_right">
        <div class="login_banner">
          <img src="@/assets/theme4/img/login_banner.jpg">
        </div>
        <div class="login_welcome">
          <h5>Welcome To Bonus365</h5>
          <p>
            Select from one of the below Welcome Offers…

            CASINO: DOUBLE your deposit up to €100, 100 Free Spins
            ands davs or 20 Free sons on selected aames Oniv new olavers denositina to-the first time are lol6 for the Casino Deposit Bonus. • The Casino Bonus is a sine deposit match ponus and will be creched ony AIready nave an account. Log in minimum first deposit of twentv Euros (€20) is required te
            cam the casino deposit bonus • Maximum total bonus
            that can be claimed is one hundred Euros (€100).

            LIVE CASINO: A 100% Deposit Match up to €100 to use
            on our award-winninglive table lezuorme is required to claim the LIVE Casino Welcome Bonus • Only new lavers depositing for the first time are eliaible for the match ponus and will be creched ony AIready nave an account. Log in minimum first deposit of twentv Euros (€20) is required te
            cam the casino deposit bonus • Maximum total bonus
            that can be claimed is one hundred Euros (€100).

            CASINO: DOUBLE your deposit up to €100, 100 Free Spins
            ands davs or 20 Free sons on selected aames Oniv new olavers denositina to-the first time are lol6 for the Casino Deposit Bonus. • The Casino Bonus is a sine deposit match ponus and will be creched ony AIready nave an account. Log in minimum first deposit of twentv Euros (€20) is required te
            cam the casino deposit bonus • Maximum total bonus
            that can be claimed is one hundred Euros (€100).

            LIVE CASINO: A 100% Deposit Match up to €100 to use
            on our award-winninglive table lezuorme is required to claim the LIVE Casino Welcome Bonus • Only new lavers depositing for the first time are eliaible for the match ponus and will be creched ony AIready nave an account. Log in minimum first deposit of twentv Euros (€20) is required te
            cam the casino deposit bonus • Maximum total bonus
            that can be claimed is one hundred Euros (€100).
          </p>
        </div>
      </div>
    </div>
    <div class="login_header login_header2">
      <header-mobile />
    </div>
  </div>
</template>

<script>
import headerMobile from '@/components/headerMobile'
import { login } from '@/api/user'
import { login as localLogin } from '@/utils/user'
import { setErrorMessage } from '@/utils/tool'
import { VueTelInput } from 'vue-tel-input'

export default {
  components: {
    headerMobile,
    VueTelInput
  },
  data() {
    const postForm = {
      username: null,
      password: null,
      captcha: null
    }

    return {
      postForm,
      countryList: [],
      defaultCountry: '',
      actionLoading: false,
      loginType: 'username'
    }
  },
  created() {
    this.countryList = this.$store.getters.supportPhoneCode
    this.defaultCountry = this.countryList[0]
  },
  methods: {
    changeLoginType(type) {
      this.loginType = type
    },
    handleUpdate() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.actionLoading = true
          login(this.postForm).then(response => {
            let redirect = 'index'
            if (this.$store.getters.inviteCode !== null) {
              redirect = 'user'
            } else if (this.$route.query.redirect) {
              redirect = this.$route.query.redirect
            }
            this.$store.commit('SET_READ_TERMS', false)
            localLogin(response.data.data, redirect)
          }).catch((error) => {
            setErrorMessage(error.response, this.errors)
          }).finally((e) => {
            this.actionLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
